import React from 'react';
import { Tag } from '@bedrock/components';
import type { TagProps } from '@bedrock/components/lib/Tag';
import './index.less';

/** AI Tag 视觉变体 */
export type AiTagVariant = 'filled' | 'outlined';

export interface AiTagProps extends Omit<TagProps, 'color'> {
  /** AI 渐变样式变体，filled=渐变填充白字，outlined=浅色背景蓝色边框蓝字 */
  variant?: AiTagVariant;
}

/**
 * AiTag — 基于 bedrock Tag 的 AI 渐变样式扩展
 *
 * - `variant="filled"`: 蓝紫渐变背景 + 白色文字（实心）
 * - `variant="outlined"`: 浅蓝背景 + 蓝色边框 + 蓝色文字（边框）
 *
 * 其余 props 原样透传给 Tag 组件。
 */
/**
 * 将 0~1 的小数格式化为百分比文本（精确计算）
 * 如 0.4 → "40%"，0.6667 → "66.67%"，null → "--"
 */
export function formatAiPercent(val: number | null | undefined): string {
  if (val == null) return '--';
  const n = Number(val);
  if (Number.isNaN(n)) return '--';
  // 保留最多 2 位小数，去掉末尾 0
  return `${parseFloat(n.toFixed(2))}%`;
}

export default function AiTag({ variant = 'filled', className, ...rest }: AiTagProps) {
  const cls = ['ai-tag', `ai-tag--${variant}`, className].filter(Boolean).join(' ');
  return <Tag {...rest} className={cls} color="light-blue" />;
}
